import { ArrowLeft } from "lucide-react"
import { Link } from "react-router-dom"

export default function UnknownPage() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-screen bg-gray-100">
      <h1 className="text-8xl font-bold text-gray-800 mb-2 tracking-wide">404</h1>
      <h2 className="text-2xl font-semibold text-gray-600 mb-8">Nothing Here</h2>
      <Link
        // href="/"
        to="/dashboard"
        className="inline-flex items-center px-4 py-2 bg-[#0E156F] text-white font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 transition-colors"
      >
        <ArrowLeft className="w-5 h-5 mr-2" />
        Go Back to Home
      </Link>
    </div>
  )
}
